import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
export function UrgencyCountdown() {
  // Start with 23:33:41
  const [timeLeft, setTimeLeft] = useState({
    h: 23,
    m: 33,
    s: 41
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          h,
          m,
          s
        } = prev;
        if (s > 0) {
          s--;
        } else {
          s = 59;
          if (m > 0) {
            m--;
          } else {
            m = 59;
            if (h > 0) h--;
          }
        }
        return {
          h,
          m,
          s
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const format = (num: number) => num.toString().padStart(2, '0');
  return <section className="w-full bg-brand-blue py-12 px-4 text-white" data-id="element-469">
      <div className="max-w-3xl mx-auto text-center" data-id="element-470">
        <h2 className="text-2xl md:text-3xl font-bold mb-6" data-id="element-471">
          ⏰ EL PRECIO DE LANZAMIENTO TERMINA EN:
        </h2>

        <div className="flex justify-center gap-4 mb-6" data-id="element-472">
          <div className="flex flex-col items-center" data-id="element-473">
            <div className="bg-slate-900 text-white text-4xl md:text-5xl font-bold p-4 rounded-lg min-w-[80px]" data-id="element-474">
              {format(timeLeft.h)}
            </div>
            <span className="text-xs text-blue-200 mt-2 uppercase tracking-wider" data-id="element-475">
              Horas
            </span>
          </div>
          <div className="text-4xl md:text-5xl font-bold py-4" data-id="element-476">:</div>
          <div className="flex flex-col items-center" data-id="element-477">
            <div className="bg-slate-900 text-white text-4xl md:text-5xl font-bold p-4 rounded-lg min-w-[80px]" data-id="element-478">
              {format(timeLeft.m)}
            </div>
            <span className="text-xs text-blue-200 mt-2 uppercase tracking-wider" data-id="element-479">
              Minutos
            </span>
          </div>
          <div className="text-4xl md:text-5xl font-bold py-4" data-id="element-480">:</div>
          <div className="flex flex-col items-center" data-id="element-481">
            <div className="bg-slate-900 text-white text-4xl md:text-5xl font-bold p-4 rounded-lg min-w-[80px]" data-id="element-482">
              {format(timeLeft.s)}
            </div>
            <span className="text-xs text-blue-200 mt-2 uppercase tracking-wider" data-id="element-483">
              Segundos
            </span>
          </div>
        </div>

        <p className="text-xl text-blue-100 mb-8 font-medium" data-id="element-484">
          Después sube $15.000 ARS y no vuelve a bajar.
        </p>

        <div className="max-w-md mx-auto bg-slate-800/50 p-6 rounded-xl border border-blue-800/50" data-id="element-485">
          <div className="flex justify-between text-sm font-bold mb-2" data-id="element-486">
            <span className="text-red-400 flex items-center gap-2" data-id="element-487">
              <span className="animate-pulse" data-id="element-488">🔴</span> Cupos al precio de
              lanzamiento — Quedan pocos
            </span>
            <span className="text-white" data-id="element-489">68% de los cupos tomados</span>
          </div>
          <div className="w-full bg-slate-900 rounded-full h-4 overflow-hidden" data-id="element-490">
            <motion.div initial={{
            width: 0
          }} animate={{
            width: '68%'
          }} transition={{
            duration: 1.5,
            ease: 'easeOut'
          }} className="bg-gradient-to-r from-red-500 to-brand-amber h-full rounded-full" data-id="element-491" />
          </div>
        </div>
      </div>
    </section>;
}